import {IBizChallenge, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {AChallenge} from "@/views/editor/service/challenge/challenge";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";

export class Task extends AChallenge implements IBizChallenge {
    readonly opt: { [key: string]: unknown }

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as { [key: string]: unknown }
    }

    resetMeta(): IBusiness {
        console.log('Task reset meta');
        return this;
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return []
    }

}